export default "__VITE_ASSET__44a462cb__"